import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useAuth from '../../auth/useAuth';

import './styles.css';

// Formats "YYYY-MM-DD" → "September 15, 2026". Falls back to the raw
// string if parsing fails so we never render "Invalid Date".
function formatEndDate(iso) {
  if (!iso) return '';
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  const date = new Date(y, m - 1, d);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric'
  });
}

export default function SubscriptionExpired() {
  const navigate = useNavigate();
  const { getUser, logout, isStudent } = useAuth();

  const user = getUser();
  const endDate = user?.subscription?.end_date;

  // Belt-and-suspenders: if a non-student or an active-subscription user
  // somehow lands here, bounce them to the app. The Login onSuccess is
  // the primary gate.
  useEffect(() => {
    if (!user) {
      navigate('/acc/login', { replace: true });
      return;
    }
    if (!isStudent() || user?.subscription?.is_active) {
      navigate('/assignments', { replace: true });
    }
  }, [user, isStudent, navigate]);

  return (
    <div className="subscription-expired-page">
      <div className="subscription-expired-container">
        <svg
          className="subscription-expired-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="40" height="40" viewBox="0 0 24 24"
          fill="none" stroke="#2A4169" strokeWidth="1.75"
          strokeLinecap="round" strokeLinejoin="round"
          aria-hidden="true"
        >
          <rect x="3" y="4" width="18" height="18" rx="2" />
          <path d="M16 2v4M8 2v4M3 10h18" />
          <path d="M9 15l6 4M15 15l-6 4" />
        </svg>
        <h1 className="subscription-expired-title">
          Your course subscription has expired
        </h1>
        <p className="subscription-expired-body">
          You&rsquo;re signed in, but access to your course materials ended
          on {formatEndDate(endDate) || <span className="subscription-expired-date-placeholder">[EXPIRY DATE]</span>}.
          To continue learning, please reach out to your instructor to renew
          your subscription.
        </p>
        <p className="subscription-expired-note">
          Your progress and submissions are saved and will be available again
          once your subscription is renewed.
        </p>
        <button
          type="button"
          className="subscription-expired-logout"
          onClick={logout}
        >
          Log out
        </button>
      </div>
    </div>
  );
}
